<template>
    <div class="ratio">
        <iframe v-on:load="onLoad($event)"/>
        <div>
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    fontSize: Boolean,
    ratio: Number
  },
  data () {
    return {
      element: null
    }
  },
  watch: {
    ratio () {
      this.apply()
    }
  },
  methods: {
    onLoad (e) {
      // Get elements
      const i = e.target
      this.element = i.parentNode.querySelector('div')

      // Update style
      i.style.border = 'none'
      i.style.display = 'block'
      i.style.position = 'absolute'
      i.style.top = 0
      i.style.left = 0
      i.style.height = '100%'
      i.style.width = '100%'

      // Apply ratio once (in Chrome the resize event is not fired on load)
      this.apply()

      // Listen to resize
      i.contentWindow.addEventListener('resize', this.apply.bind(this))
    },
    apply () {
      if (this.element.parentNode.offsetWidth > this.element.parentNode.offsetHeight * this.ratio) {
        this.element.style.height = this.element.parentNode.offsetHeight + 'px'
        this.element.style.width = (this.element.parentNode.offsetHeight * this.ratio).toString() + 'px'
      } else {
        this.element.style.height = (this.element.parentNode.offsetWidth / this.ratio).toString() + 'px'
        this.element.style.width = this.element.parentNode.offsetWidth + 'px'
      }
      if (this.fontSize) this.element.style.fontSize = this.element.style.height
    }
  }
}
</script>

<style scoped>

.ratio {
  display: flex;
  position: relative;
}

.ratio > iframe {
  display: none;
}

.ratio > div {
  height: 100%;
  margin: auto;
  position: relative;
  width: 100%;
}

</style>
